export default function FieldNameToOptionSwitch(str = '') {
    let s = str.toLowerCase();
    let positiveTitle = 'true';
    let negativeTitle = 'false';
    if (s.includes('enabled') || s.includes('disabled')) {
        positiveTitle = 'Enabled';
        negativeTitle = 'Disabled';
    } else if (s.includes('active') || s.includes('inactive')) {
        positiveTitle = 'Active';
        negativeTitle = 'Inactive';
    }
    return [
        { title: positiveTitle, value: 'true' },
        { title: negativeTitle, value: 'false' }
    ];
}
